export const theoryChapters = [];

export const theoryGroups = [
  { label: 'Prescriptions légales',       chapters: [], special: 'prescriptions' },
  { label: 'Fondements',                  chapters: [], special: 'fondaments' },
  { label: 'TVA suisse',                  chapters: [], special: 'tva' },
  { label: 'Salaires & charges sociales', chapters: [], special: 'salaires' },
  { label: 'Marchandises & stocks',       chapters: [], special: 'marchandises' },
  { label: 'Bouclement annuel',           chapters: [], special: 'bouclement' },
  { label: 'Hors exploitation',           chapters: [], special: 'hors-exploitation' },
];